export default __webpack_public_path__ + "static/media/FamilyRoom.a578289f.jpeg";